import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-969971c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap-top" }
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = { class: "report-verify" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "report-banner" }, null, -1))

import { ref, reactive, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import { selectReport } from "@/service/testReport/request.js";
import Enumeration from "@/service/enumeration.js";


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportVerify',
  setup(__props) {

const route = useRoute();
const reportNumber = ref(); // 报告编号
const reportData = reactive({
  startTime: "",
  thesisTitle: "",
  thesisPage: "",
  fileType: "",
  questionNum: "",
  templateName: "",
  checkResult: "",
});

// 获取查验报告
const getSelectReport = async () => {
  const res = await selectReport(reportNumber.value);
  try {
    if (res && res.code && res.code == 200) {
      reportData.startTime = res.data.startTime;
      reportData.thesisTitle = res.data.thesisTitle;
      reportData.thesisPage = res.data.thesisPage;
      reportData.fileType = res.data.fileType;
      reportData.questionNum = res.data.questionNum;
      reportData.templateName = res.data.templateName;
      Enumeration.detectionResult.find((item) => {
        if (item.key == res.data.checkResult) {
          reportData.checkResult = item.value;
        }
      });
    }
  } catch (error) {
    // console.log(error);
  }
};

const isMobile = () => {
  if (route.query.checkSn) {
    reportNumber.value = route.query.checkSn;
    getSelectReport();
  }
};

onMounted(() => {
  isMobile();
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_el_card, { shadow: "never" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { class: "no-wrap" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: reportNumber.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((reportNumber).value = $event)),
                  size: "large",
                  placeholder: "请输入报告编号",
                  clearable: ""
                }, {
                  append: _withCtx(() => [
                    _createVNode(_component_el_button, { onClick: getSelectReport }, {
                      default: _withCtx(() => [
                        _createTextVNode("开始验证")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions, {
              column: 1,
              size: "large",
              border: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_descriptions_item, {
                  label: "检测模板",
                  "label-align": "center",
                  align: "center"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(reportData.templateName), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, {
                  label: "检测时间",
                  "label-align": "center",
                  align: "center"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(reportData.startTime), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, {
                  label: "文档页数",
                  "label-align": "center",
                  align: "center"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(reportData.thesisPage), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, {
                  label: "文档类型",
                  "label-align": "center",
                  align: "center"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(reportData.fileType), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, {
                  label: "文档名称",
                  "label-align": "center",
                  align: "center"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(reportData.thesisTitle), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, {
                  label: "检测结果",
                  "label-align": "center",
                  align: "center"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(reportData.checkResult), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, {
                  label: "问题总数",
                  "label-align": "center",
                  align: "center"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(reportData.questionNum), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})